import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResponse } from 'src/app/backend-client/models/SharedKernel/Models/Error/error-response';
import { MxNotificationService, MxNotificationSeverity } from 'src/app/core/services/mx.notification.service';

/**
 * Szirom Pont szerverhibák a komponensekben. A szerver az üzleti hibákat (AppException) 400-as ErrorResponse-ként
 * küldi: errorCode + magyar friendlyMessage. Ha a hívó saját error-ágat ad a subscribe-nak, a globális hibakezelő
 * nem kapja meg a hibát, ezért az üzenetet itt kell megjeleníteni.
 */

/** A szerver ErrorResponse-a a hibából (HttpErrorResponse vagy a 401-nél már kicsomagolt törzs). */
export function loyaltyErrorBody(error: unknown): ErrorResponse | null {
  const body = error instanceof HttpErrorResponse ? error.error : error;
  return body && typeof body === 'object' && ('errorCode' in body || 'friendlyMessage' in body) ? (body as ErrorResponse) : null;
}

/** A szerver hibakódja (pl. LOYALTY_REPORT_CONFLICT), ha van. */
export function loyaltyErrorCode(error: unknown): string | null {
  return loyaltyErrorBody(error)?.errorCode ?? null;
}

/** Párhuzamos elbírálás (…_CONFLICT): a lista elavult, frissíteni kell. */
export function isLoyaltyConflict(error: unknown): boolean {
  return !!loyaltyErrorCode(error)?.endsWith('_CONFLICT');
}

/** A szerver barátságos üzenete toastként; ha nincs (hálózati hiba stb.), a megadott tartalék szöveg. */
export function showLoyaltyError(notificationService: MxNotificationService, error: unknown, fallback = 'A művelet nem sikerült, próbáld újra.') {
  // az interceptor 403/404/egyéb hibánál már elnavigált és szöveget dob tovább: ott nincs mit mutatni
  if (typeof error === 'string') return;
  const body = loyaltyErrorBody(error);
  notificationService.show({
    type: body?.severity != null ? notificationService.getNotificationSeverityByBackendNotificationType(body.severity) ?? MxNotificationSeverity.Warn : MxNotificationSeverity.Warn,
    title: body?.errorTitle || 'Szirom Pont',
    message: body?.friendlyMessage || fallback,
  });
}
